/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { PortfolioCategory } from './';
import {
    PortfolioCategoryFromJSON,
    PortfolioCategoryFromJSONTyped,
    PortfolioCategoryToJSON,
} from './';

/**
 * 
 * @export
 * @interface PortfolioInspirationItemResource
 */
export interface PortfolioInspirationItemResource {
    /**
     * 
     * @type {string}
     * @memberof PortfolioInspirationItemResource
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioInspirationItemResource
     */
    profileId: string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioInspirationItemResource
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioInspirationItemResource
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioInspirationItemResource
     */
    thumbnail: string;
    /**
     * 
     * @type {PortfolioCategory}
     * @memberof PortfolioInspirationItemResource
     */
    category?: PortfolioCategory;
    /**
     * 
     * @type {string}
     * @memberof PortfolioInspirationItemResource
     */
    freelancerFirstName?: string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioInspirationItemResource
     */
    freelancerLastName?: string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioInspirationItemResource
     */
    freelancerAvatarUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioInspirationItemResource
     */
    freelancerSeoAlias?: string;
}

/**
 * Check if a given object implements the PortfolioInspirationItemResource interface.
 */
export function instanceOfPortfolioInspirationItemResource(value: object): value is PortfolioInspirationItemResource {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('profileId' in value) || value['profileId'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('thumbnail' in value) || value['thumbnail'] === undefined) return false;
    return true;
}

export function PortfolioInspirationItemResourceFromJSON(json: any): PortfolioInspirationItemResource {
    return PortfolioInspirationItemResourceFromJSONTyped(json, false);
}

export function PortfolioInspirationItemResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortfolioInspirationItemResource {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'profileId': json['profileId'],
        'title': json['title'],
        'description': json['description'],
        'thumbnail': json['thumbnail'],
        'category': json['category'] == null ? undefined : PortfolioCategoryFromJSON(json['category']),
        'freelancerFirstName': json['freelancerFirstName'] == null ? undefined : json['freelancerFirstName'],
        'freelancerLastName': json['freelancerLastName'] == null ? undefined : json['freelancerLastName'],
        'freelancerAvatarUrl': json['freelancerAvatarUrl'] == null ? undefined : json['freelancerAvatarUrl'],
        'freelancerSeoAlias': json['freelancerSeoAlias'] == null ? undefined : json['freelancerSeoAlias'],
    };
}

export function PortfolioInspirationItemResourceToJSON(value?: PortfolioInspirationItemResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'profileId': value['profileId'],
        'title': value['title'],
        'description': value['description'],
        'thumbnail': value['thumbnail'],
        'category': PortfolioCategoryToJSON(value['category']),
        'freelancerFirstName': value['freelancerFirstName'],
        'freelancerLastName': value['freelancerLastName'],
        'freelancerAvatarUrl': value['freelancerAvatarUrl'],
        'freelancerSeoAlias': value['freelancerSeoAlias'],
    };
}

